import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import { pageTransition, pageTransitionSettings } from '@/animations/variants';

export default function MainLayout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      
      <motion.main 
        className="flex-1"
        variants={pageTransition}
        initial="initial"
        animate="in"
        exit="out"
        transition={pageTransitionSettings}
      >
        <Outlet />
      </motion.main>
      
      <Footer />
    </div>
  );
}